// @ts-nocheck
import {Column} from 'react-table'
import {EmployersInfoCell} from './EmployersInfoCell'
import {EmployersTwoStepsCell} from './EmployersTwoStepsCell'
import {EmployersActionsCell} from './EmployersActionsCell'
import {EmployersCustomHeader} from './EmployersCustomHeader'
import {Employers} from '../../core/_models'

const EmployersColumns: ReadonlyArray<Column<Employers>> = [
  {
    Header: (props) => (
      <EmployersCustomHeader tableProps={props} title='S.No' className='min-w-125px' />
    ),
    accessor: 'serialNo',
  },
  {
    Header: (props) => (
      <EmployersCustomHeader tableProps={props} title='Name' className='min-w-125px' />
    ),
    id: 'name',
    Cell: ({...props}) => <EmployersInfoCell employers={props.data[props.row.index]} />,
  },
 

  // {
  //   Header: (props) => (
  //     <EmployersCustomHeader tableProps={props} title='Role' className='min-w-125px' />
  //   ),
  //   accessor: 'role.roleName',
  // },
  {
    Header: (props) => (
      <EmployersCustomHeader tableProps={props} title='Company Name' className='min-w-125px' />
    ),
    accessor: 'company',
  },
  {
    Header: (props) => (
      <EmployersCustomHeader tableProps={props} title='Designation' className='min-w-125px' />
    ),
    accessor: 'designation',
  },
  {
    Header: (props) => (
      <EmployersCustomHeader tableProps={props} title='Mobile' className='min-w-125px' />
    ),
    accessor: 'mobile',
  },
  

  {
    Header: (props) => (
      <EmployersCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <EmployersActionsCell employers={props.data[props.row.index]} />,
  },
]

export {EmployersColumns}
